var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExportReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download-arrow",
    transform: "translate(1.001 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M.4,15a.408.408,0,0,1-.4-.417V10.544a.4.4,0,0,1,.4-.411.408.408,0,0,1,.4.411v3.628h13.39V10.544a.4.4,0,0,1,.4-.411.408.408,0,0,1,.406.411v4.039a.413.413,0,0,1-.406.417Zm6.816-3.47L3.636,7.849a.419.419,0,0,1,0-.587.392.392,0,0,1,.571,0L7.1,10.233V.417A.413.413,0,0,1,7.5,0a.408.408,0,0,1,.4.417v9.817l2.894-2.971a.385.385,0,0,1,.565,0,.419.419,0,0,1,0,.587L7.786,11.53a.407.407,0,0,1-.287.119A.392.392,0,0,1,7.215,11.53Z",
    transform: "translate(-0.001)",
    fill: "none",
    stroke: "#007cab",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportReport);
export default __webpack_public_path__ + "static/media/ExportReport.2acff1ab7b033613975e4cb8d956a98e.svg";
export { ForwardRef as ReactComponent };